module.exports = __webpack_public_path__ + "static/media/user.f4a29a82.svg";